module.exports = __webpack_public_path__ + "img/GHN.d287401b.png";